import actionTypes from './actionTypes'

const privateLibraryActions = {

	initializeLibraryBase() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_INITIALIZE_LIBRARY_BASE,
		}
	},

	initializeFolder(folderUID, libraryUID) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_INITIALIZE_FOLDER,
			folderUID,
			libraryUID,
		}
	},

	finalizePrivateLibrary() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_FINALIZE,
		}
	},

	getPrivateLibraryNextPage() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_LESSONS_NEXT_PAGE,
		}
	},

	initializePreview(entity_ID, entity_type, libraryUID) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_INITIALIZE_PREVIEW,
			entity_ID,
			entity_type,
			libraryUID,
		}
	},

	toggleFullLessons() {
		return {
			type: actionTypes.PREVIEW_TOGGLE_FULL_LESSONS,
		}
	},

	editPrivateLibrarySettings() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_EDIT_SETTINGS,
		}
	},

	submitPrivateLibrarySettings(values, resolve, reject) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_SETTINGS_SUBMIT,
			values,
			resolve,
			reject,
		}
	},

	updateLessonsSort(order_field, order_type) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_LESSONS_SORT_UPDATE,
			order_field,
			order_type,
		}
	},

	getFilterDefinitions() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_GET_FILTER_DEFINITIONS,
		}
	},

	openFindLessonsModal() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_FIND_LESSONS_MODAL_OPEN,
		}
	},

	closeFindLessonsModal() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_FIND_LESSONS_MODAL_CLOSE,
		}
	},

	updateSearchSort(order_field, order_type) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_SEARCH_SORT_UPDATE,
			order_field,
			order_type,
		}
	},

	updateSearchQueryKeyword(keyword) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_SEARCH_QUERY_UPDATE,
			keyword,
		}
	},

	updateSearchFilters(filters) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_SEARCH_FILTERS_UPDATE,
			filters,
		}
	},

	getPrivateLibrarySearchNextPage() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_SEARCH_NEXT_PAGE,
		}
	},

	toggleSearchItem(id) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_SEARCH_TOGGLE_ITEM,
			id,
		}
	},

	current_toggleFilterSelection(entityUID) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_CURRENT_TOGGLE_FILTER_SELECTION,
			entityUID,
		}
	},

	current_clearSearch() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_CURRENT_CLEAR_SEARCH,
		}
	},

	current_applySearch() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_CURRENT_APPLY_SEARCH,
		}
	},

	current_applyRedirectSearch(libraryUID) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_CURRENT_APPLY_REDIRECT_SEARCH,
			libraryUID,
		}
	},

	current_searchInputChange(value) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_CURRENT_SEARCH_INPUT_CHANGE,
			value,
		}
	},

	current_toggleFiltersModal() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_CURRENT_TOGGLE_FILTERS_MODAL,
		}
	},

	findLessons_toggleFilterSelection(entityUID) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_FIND_LESSONS_TOGGLE_FILTER_SELECTION,
			entityUID,
		}
	},

	findLessons_clearSearch() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_FIND_LESSONS_CLEAR_SEARCH,
		}
	},

	findLessons_applySearch() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_FIND_LESSONS_APPLY_SEARCH,
		}
	},

	findLessons_searchInputChange(value) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_FIND_LESSONS_SEARCH_INPUT_CHANGE,
			value,
		}
	},

	findLessons_toggleFiltersModal() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_FIND_LESSONS_TOGGLE_FILTERS_MODAL,
		}
	},

	findLessons_toggleShowAll() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_FIND_LESSONS_TOGGLE_SHOW_SELECTED,
		}
	},

	findLessons_toggleSelectAll() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_FIND_LESSONS_TOGGLE_SELECT_ALL,
		}
	},

	findLessons_addLessons() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_FIND_LESSONS_ADD_LESSONS,
		}
	},

	findLessons_addLessons_confirm() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_FIND_LESSONS_ADD_LESSONS_CONFIRMED,
		}
	},

	findLessons_addLessons_cancel() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_FIND_LESSONS_ADD_LESSONS_CANCELLED,
		}
	},

	findLessons_preview(entity, bundleId, privateLibraryId) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_FIND_LESSONS_PREVIEW,
			entity,
			bundleId,
			privateLibraryId,
		}
	},

	nameFolder_inputChange(value) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_NAME_FOLDER_INPUT_CHANGE,
			value,
		}
	},

	nameFolder_submit() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_NAME_FOLDER_SUBMIT,
		}
	},

	nameFolder_cancel() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_NAME_FOLDER_CANCEL,
		}
	},

	openNewFolderModal() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_OPEN_NEW_FOLDER_MODAL,
		}
	},

	openNewFolderModalWithEntity(productUid, productType) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_OPEN_NEW_FOLDER_MODAL_WITH_ENTITY,
			productUid,
			productType,
		}
	},

	openRenameFolderModal() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_OPEN_RENAME_FOLDER_MODAL,
		}
	},

	openDeleteCurrentFolderConfirm() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_OPEN_DELETE_CURRENT_FOLDER_CONFIRM,
		}
	},

	deleleteCurrentFolder_confirm() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_DELETE_CURRENT_FOLDER_CONFIRM,
		}
	},

	deleteCurrentFolder_cancel() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_DELETE_CURRENT_FOLDER_CANCEL,
		}
	},

	addToFolder(entity) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_FOLDER_PROMPT_ADD_LESSON,
			entity,
		}
	},

	removeFromFolder(entity, folderUID) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_FOLDER_REMOVE_LESSON,
			entity: entity.entityType==='3'?entity.entityUID:entity.entityID,
			entityType: entity.entityType,
			folderUID,
		}
	},

	deleteEntity(entity) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_DELETE_LESSON,
			entity,
		}
	},

	addLessonToFolderCancel(entityUID, entityType) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_FOLDER_ADD_LESSON_CANCEL,
			entityUID,
			entityType,
		}
	},

	addLessonToFolder(lessons, bundles, folder_id) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_FOLDER_ADD_LESSON,
			bundles,
			lessons,
			folder_id,
		}
	},

	changeFolderColorClick(colorID) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_CHANGE_FOLDER_COLOR_CLICK,
			colorID,
		}
	},

	openAddLessonsToFolder() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_OPEN_ADD_LESSONS_TO_FOLDER,
		}
	},

	addLessonToFolderSuccess(data) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_FOLDER_ADD_LESSON_SUCCESS,
			data,
		}
	},

	nameFolderSuccess(data, folderUID) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_NAME_FOLDER_SUCCESS,
			data,
			folderUID,
		}
	},

	nameFolderError(error) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_NAME_FOLDER_ERROR,
			error,
		}
	},

	changeFolderColorSuccess(folders, name, color, parents, isAdmin) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_CHANGE_FOLDER_COLOR_SUCCESS,
			folders,
			name,
			color,
			parents,
			isAdmin,
		}
	},

	changeFolderColorError(error) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_CHANGE_FOLDER_COLOR_ERROR,
			error,
		}
	},

	lessonsPickerSearchLessons() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_LESSONS_PICKER_SEARCH_LESSONS,
		}
	},

	lessonsPickerInit() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_LESSONS_PICKER_INIT,
		}
	},

	lessonsPickerSaveLessons() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_LESSONS_PICKER_SAVE_LESSONS,
		}
	},

	lessonsPickerAddSuccess(presentationUIDs) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_LESSONS_PICKER_ADD_SUCCESS,
			presentationUIDs,
		}
	},

	lessonsPickerAddError(error) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_LESSONS_PICKER_ADD_ERROR,
			error,
		}
	},

	lessonsPickerCancel() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_LESSONS_PICKER_CANCEL,
		}
	},

	deleteLesson_confirm() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_DELETE_LESSON_CONFIRMED,
		}
	},

	deleteLesson_cancel() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_DELETE_LESSON_CANCELLED,
		}
	},

	focusFilters() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_FOCUS_FILTERS,
		}
	},

	focusFiltersClear() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_FOCUS_FILTERS_CLEAR,
		}
	},

	toggleInfo() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_TOGGLE_INFO,
		}
	},

	addToPrivateLibrary(entityType, entityID, entityUID, bundlePresentations, libraryType, libraryId, currentLibraryUID) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_ADD_TO_PRIVATE_LIBRARY,
			entityType,
			entityID,
			entityUID,
			bundlePresentations,
			libraryType,
			libraryId,
			currentLibraryUID,
		}
	},

	lessonAlreadyAdded(libraryType, entityType) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_LESSON_ALREADY_ADDED,
			libraryType,
			entityType,
		}
	},

	previewUnmount() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_PREVIEW_UNMOUNT,
		}
	},

	manageLibrary_confirm(libraryId) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_MANAGE_LIBRARY_REDIRECT,
			libraryId,
		}
	},

	viewLibrary_confirm(libraryId) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_VIEW_LIBRARY_REDIRECT,
			libraryId,
		}
	},

	preserveLibrarySearch() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_PRESERVE_LIBRARY_SEARCH,
		}
	},

	switchLibrary() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_SWITCH_LIBRARY,
		}
	},

	redirectToLibrary(libraryUID) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_REDIRECT_TO_LIBRARY,
			libraryUID,
		}
	},

	initializeContentPackage() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_INITIALIZE_CONTENT_PACKAGE,
		}
	},

	findLessons_addLessons_multipleSchools() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_FIND_LESSONS_ADD_LESSONS_MULTIPLE_SCHOOLS_CONFIRMED,
		}
	},

	findLessons_addLessons_singleSchool() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_FIND_LESSONS_ADD_LESSONS_MULTIPLE_SCHOOLS_DENIED,
		}
	},
	findLessons_addLessons_multipleSchools_cancel() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_FIND_LESSONS_ADD_LESSONS_MULTIPLE_SCHOOLS_CANCELLED,
		}
	},

	deleteLesson_multipleSchools_confirm() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_DELETE_LESSON_MULTIPLE_SCHOOLS_CONFIRMED,
		}
	},

	deleteLesson_multipleSchools_cancel() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_DELETE_LESSON_MULTIPLE_SCHOOLS_CANCELLED,
		}
	},

	shareLesson(entityUID, entityType, libraryUID) {
		return {
			type: actionTypes.MY_LIBRARY_SHARE_LESSON,
			entityUID,
			entityType,
			libraryUID,

		}
	},

	learnMorePackages(redirectUrl) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_LEARN_MORE_PACKAGES,
			redirectUrl,
		}
	},

	unlockSampleLessons(redirectUrl) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_UNLOCK_SAMPLE_LESSONS,
			redirectUrl,
		}
	},

	unlockOverlayOpen(library) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_UNLOCK_OVERLAY_OPEN,
			library,
		}
	},

	moveLessonRelease(lesson_id, bundle_id, sourceUID, sourceName, presentationsCount, targetFolderID, targetName, libraryUID) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_MOVE_LESSON_RELEASE,
			lessons: [lesson_id],
			bundles: [bundle_id],
			sourceUID,
			sourceName,
			presentationsCount,
			targetFolderID,
			targetName,
			libraryUID,
		}
	},

	moveLessonSuccess() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_FOLDER_MOVE_LESSON_SUCCESS,
		}
	},

	moveFolderRelease(sourceFolderID, sourceName, presentationsCount, targetFolderID, targetName, libraryUID) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_MOVE_FOLDER_RELEASE,
			sourceFolderID,
			sourceName,
			presentationsCount,
			targetFolderID,
			targetName,
			libraryUID,
		}
	},

	moveFolderSuccess() {
		return {
			type: actionTypes.PRIVATE_LIBRARY_FOLDER_MOVE_FOLDER_SUCCESS,
		}
	},

	moveError(error) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_MOVE_ERROR,
			error,
		}
	},

	overlaySchoolLibraryOnboardingInitialize() {
		return {
			type: actionTypes.OVERLAY_SCHOOL_LIBRARY_ONBOARDING_INITIALIZE,
		}
	},

	overlayDistrictLibraryOnboardingInitialize() {
		return {
			type: actionTypes.OVERLAY_DISTRICT_LIBRARY_ONBOARDING_INITIALIZE,
		}
	},

	overlaySchoolLibraryOnboardingConfirm() {
		return {
			type: actionTypes.OVERLAY_SCHOOL_LIBRARY_ONBOARDING_CONFIRM,
		}
	},

	overlayDistrictLibraryOnboardingConfirm() {
		return {
			type: actionTypes.OVERLAY_DISTRICT_LIBRARY_ONBOARDING_CONFIRM,
		}
	},

	folderSelected(libraryUID, folderId, isAdmin) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_FOLDER_SELECTED,
			libraryUID,
			folderId,
			isAdmin,
		}
	},

	launchVideoPreview(presentation_uid) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_LAUNCH_VIDEO_PREVIEW,
			presentation_uid,
		}
	},

	launchFrontOfTheClassroomSessionFetched(payload) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_PREVIEW_LAUNCH_FRONT_OF_THE_CLASSROOM_SESSION_FETCHED,
			payload,
		}
	},

	launchFrontOfTheClassroomSessionFailed(serverError) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_PREVIEW_LAUNCH_FRONT_OF_THE_CLASSROOM_SESSION_FAILED,
			serverError,
		}
	},

	initializeVideoPreview(presentation_uid) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_INITIALIZE_VIDEO_PREVIEW,
			presentation_uid,
		}
	},

	launchFrontOfTheClassroomPreview(presentation_uid) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_PREVIEW_LAUNCH_FRONT_OF_THE_CLASSROOM,
			presentation_uid,
		}
	},

	launchAllDevicesPreview(presentation_uid) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_PREVIEW_LAUNCH_ALL_DEVICES,
			presentation_uid,
		}
	},

	launchStudentPacedPreview(presentation_uid) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_PREVIEW_LAUNCH_STUDENT_PACED,
			presentation_uid,
		}
	},

	getPrivateLibraryFoldersDataSuccess(folders, name, parents, color, isAdmin) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_FOLDERS_FETCH_SUCCESS,
			folders,
			name,
			parents,
			color,
			isAdmin,
		}
	},

	getPrivateLibraryFoldersDataFailed(error) {
		return {
			type: actionTypes.PRIVATE_LIBRARY_FOLDERS_FETCH_FAILED,
			error,
		}
	},
}

export default privateLibraryActions
